import { FC, useCallback } from 'react'
import { useTranslation } from '../../../../../hooks/useTranslation'
import { Trans } from 'react-i18next'
import Image from 'next/image'

import IMG_1 from '../../assets/img/team_member_1.png'
import IMG_2 from '../../assets/img/team_member_2.png'
import IMG_3 from '../../assets/img/team_member_3.png'
import IMG_BG from '../../assets/img/team-member-bg.svg'
import useMixpanel from '../../../../../hooks/useMixpanel'

const TeamMemberDesk: FC<{ setIsLazyLoading?; getRef?; getRefMobile? }> = ({ setIsLazyLoading, getRef, getRefMobile }) => {
  const { translate } = useTranslation()
  const Mixpanel = useMixpanel()
  const handleScrollToSection = useCallback(() => {
    // console.log(contactRef.current)
    setIsLazyLoading(false)
    return Promise.all([
      getRef()?.then((targetRef) => {
        targetRef?.current?.scrollIntoView()
      }),

      getRefMobile()?.then((targetRef) => {
        targetRef?.current?.scrollIntoView()
      })
    ]).then(() => {
      return
    })
  }, [])
  return (
    <div className="team-member">
      <div className="team-member-bg">
        <Image src={IMG_BG.src} alt="img_1" width={242} height={135} />
      </div>
      <div className="team-member-container">
        <div className="heading-wrapper">
          <h2 className="heading">
            <Trans i18nKey="page_employer_headhunt_service:lp_our_recruiting_expert">
              <span className="high-light" />
            </Trans>
          </h2>
          <div className="sub-title">{translate('page_employer_headhunt_service:lp_team_member_desc')}</div>
        </div>
        <div className="overflow-x-auto">
          <div className="column-wrapper">
            <div className="card">
              <div className="card-image">
                <Image src={IMG_1} placeholder="blur" alt="img_1" width={247} height={304} />
              </div>
              <div className="card-name">Kazuki Kunimoto</div>
              <div className="card-position">CEO Japan Desk Recruitment</div>
              {/* <div className="card-title">Non-IT Industry</div> */}
              <div>
                <a onClick={() => handleScrollToSection()} className="card-connect">
                  {translate('page_employer_headhunt_service:connect_now')}{' '}
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M17.5 6.18262C18.0523 6.18262 18.5 6.63033 18.5 7.18262V17.1826C18.5 17.7349 18.0523 18.1826 17.5 18.1826C16.9477 18.1826 16.5 17.7349 16.5 17.1826V9.59683L8.20716 17.8897C7.81664 18.2802 7.18347 18.2802 6.79295 17.8897C6.40243 17.4991 6.40243 16.866 6.79295 16.4755L15.0858 8.18262H7.5C6.94771 8.18262 6.5 7.7349 6.5 7.18262C6.5 6.63033 6.94771 6.18262 7.5 6.18262H17.5Z"
                      fill="#6D4FED"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <div className="card">
              <div className="card-image">
                <Image src={IMG_2} placeholder="blur" alt="img_2" width={247} height={304} />
              </div>
              <div className="card-name">Linh Nguyen</div>
              <div className="card-position">Recruitment Consultant Manager</div>
              <div>
                <a onClick={() => handleScrollToSection()} className="card-connect">
                  {translate('page_employer_headhunt_service:connect_now')}{' '}
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M17.5 6.18262C18.0523 6.18262 18.5 6.63033 18.5 7.18262V17.1826C18.5 17.7349 18.0523 18.1826 17.5 18.1826C16.9477 18.1826 16.5 17.7349 16.5 17.1826V9.59683L8.20716 17.8897C7.81664 18.2802 7.18347 18.2802 6.79295 17.8897C6.40243 17.4991 6.40243 16.866 6.79295 16.4755L15.0858 8.18262H7.5C6.94771 8.18262 6.5 7.7349 6.5 7.18262C6.5 6.63033 6.94771 6.18262 7.5 6.18262H17.5Z"
                      fill="#6D4FED"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <div className="card">
              <div className="card-image">
                <Image src={IMG_3} placeholder="blur" alt="img_3" width={247} height={304} />
              </div>
              <div className="card-name">Hieu Huynh </div>
              <div className="card-position">Recruitment Consultant Manager</div>
              <div>
                <a onClick={() => handleScrollToSection()} className="card-connect">
                  {translate('page_employer_headhunt_service:connect_now')}{' '}
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M17.5 6.18262C18.0523 6.18262 18.5 6.63033 18.5 7.18262V17.1826C18.5 17.7349 18.0523 18.1826 17.5 18.1826C16.9477 18.1826 16.5 17.7349 16.5 17.1826V9.59683L8.20716 17.8897C7.81664 18.2802 7.18347 18.2802 6.79295 17.8897C6.40243 17.4991 6.40243 16.866 6.79295 16.4755L15.0858 8.18262H7.5C6.94771 8.18262 6.5 7.7349 6.5 7.18262C6.5 6.63033 6.94771 6.18262 7.5 6.18262H17.5Z"
                      fill="#6D4FED"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="text-expert">{translate('page_employer_headhunt_service:lp_orther_recruiting_experts')}</div> */}
      </div>
    </div>
  )
}

export default TeamMemberDesk
